export const allowedMonsters = [
	2473, 2545, 2543, 2474, 2546, 2544, 20350, 20348, 20349, 2995, 1219, 1713,
	1716, 3178, 3179, 1769, 1193, 2423, 1275, 1735, 1736, 1737, 1271, 3416,
	2226, 3231, 2565, 2566, 1301, 1094, 2476, 1511, 2362, 1030, 3398, 3196,
	3193, 20272, 1699, 1297, 2360, 20271, 20274, 20273, 2019, 20270, 20277,
	20276, 20275, 1305, 1095, 3404, 1096, 2133, 3792, 3794, 3758, 3759, 3793,
	2249, 1206, 1097, 1627, 2366, 2085, 2090, 1247, 1098, 1365, 2016, 1388,
	3221, 1668, 1016, 1194, 2358, 1099, 1100, 2549, 1654, 1647, 2113, 1315,
	1266, 1785, 1796, 3073, 3796, 1882, 1107, 1515, 1415, 2320, 2154, 2317,
	1867, 1974, 1039, 1101, 2424, 1702, 1102, 1873, 1874, 1494, 1633, 3177,
	1975, 3505, 1060, 3394, 3450, 3755, 2417, 1367, 3039, 1408, 1268, 2472,
	1507, 2534, 2556, 3397, 1025, 2068, 3756, 3489, 1188, 1830, 3738, 2024,
	1692, 1211, 3091, 1502, 3788, 3737, 3736, 2309, 3487, 2155, 2319, 1839,
	3250, 3181, 1103, 1267, 1307, 1300, 1638, 2223, 3228, 2996, 2153, 2365,
	1987, 1999, 2238, 3124, 2224, 3229, 1250, 1283, 1214, 1011, 3407, 1246,
	1269, 1270, 2240, 1976, 1104, 2186, 2954, 3503, 3504, 2152, 1009, 3388,
	1738, 20367, 20368, 20370, 1265, 1992, 1067, 3011, 2990, 3014, 3012, 3018,
	3010, 3013, 3016, 3015, 3017, 2470, 20422, 2465, 2468, 2475, 20421, 2464,
	20420, 3739, 1073, 1209, 1018, 1293, 2236, 2992, 1248, 2421, 2953, 2949,
	2948, 2074, 1700, 2425, 2994, 2530, 1260, 2282, 2255, 2285, 2284, 1302,
	2287, 1272, 2286, 2015, 1198, 2283, 2023, 2281, 2404, 1698, 2987, 2183,
	2177, 2176, 2185, 2179, 2182, 2175, 2184, 2178, 2180, 2181, 2174, 1384,
	1385, 3096, 3105, 3106, 1378, 1105, 3402, 3765, 1106, 3097, 1705, 1719,
	1108, 1582, 1109, 1382, 1670, 1671, 1672, 1673, 2550, 1506, 1110, 3393,
	2092, 20361, 1707, 1046, 2542, 2013, 2014, 1389, 3757, 1721, 1091, 1321,
	3411, 1111, 1112, 1380, 1113, 1781, 1493, 3420, 1504, 1409, 2018, 1114,
	2562, 20341, 20343, 20342, 20340, 1770, 1093, 1115, 3495, 1116, 1658, 1652,
	1377, 1033, 3630, 3747, 3748, 3749, 2252, 3445, 1410, 3446, 3447, 2310,
	3511, 3512, 3519, 3520, 3513, 3521, 3514, 3522, 3516, 3524, 1957, 1635,
	3208, 1655, 1117, 2991, 2942, 1416, 2939, 2940, 2941, 1418, 3153, 1205,
	3156, 3249, 1383, 1007, 3386, 2528, 2540, 2541, 2529, 1871, 1371, 1005,
	1797, 2958, 2563, 2554, 2564, 3069, 3070, 3071, 3072, 1714, 1717, 3027,
	3020, 3022, 3023, 3021, 1403, 20380, 1869, 2222, 3227, 2951, 1118, 2957,
	1319, 3041, 1119, 20369, 3442, 3507, 1753, 1309, 1391, 3414, 1783, 1253,
	3740, 1778, 2552, 2553, 2551, 1681, 2253, 3241, 1368, 2225, 3230, 1120,
	1036, 1303, 2194, 1304, 1186, 1503, 1387, 3191, 3192, 2251, 1768, 2187,
	1372, 1122, 1123, 1124, 1125, 1126, 1299, 1280, 2163, 2168, 2161, 2166,
	2165, 2164, 2169, 2162, 2167, 1086, 1040, 3405, 1885, 2466, 1369, 3497,
	1277, 3247, 2533, 1631, 3176, 1632, 1381, 1687, 3412, 3629, 1259, 1311,
	2241, 3127, 1990, 1376, 3212, 1252, 2071, 20355, 3628, 3627, 20357, 1318,
	1977, 1510, 1872, 1978, 1866, 1626, 1413, 20356, 20358, 1213, 1649, 1651,
	1680, 1989, 1127, 1773, 1628, 1128, 1004, 1129, 1636, 3631, 2418, 1035,
	1068, 1720, 2069, 20379, 1777, 2558, 1832, 3482, 3490, 3474, 3480, 3483,
	3477, 3481, 3475, 3479, 3476, 3451, 1837, 1918, 1919, 1920, 1921, 1374,
	3425, 3424, 3426, 3429, 3427, 3428, 3430, 3421, 3422, 3423, 1257, 1212,
	1772, 1029, 2072, 1130, 2316, 1517, 3108, 3109, 1131, 2561, 3506, 1072,
	1406, 1400, 1833, 3210, 1639, 1656, 1132, 1734, 1883, 1294, 2997, 2198,
	2415, 1838, 1133, 1134, 1135, 1136, 1137, 1282, 1296, 1587, 2202, 2206,
	1779, 1980, 1070, 2557, 1703, 1688, 3194, 3195, 1657, 1366, 1586, 3496,
	2156, 1306, 1881, 1880, 2559, 2367, 2370, 2369, 2368, 2952, 2136, 2398,
	3753, 3751, 3126, 1505, 1646, 1373, 2131, 1994, 1509, 1063, 3385, 3252,
	3251, 1706, 2467, 1836, 1138, 1310, 2993, 2311, 1020, 2312, 1139, 1513,
	1045, 1140, 1637, 3209, 1242, 3399, 1141, 1142, 1143, 1144, 1145, 1090,
	3632, 3750, 1146, 1884, 1147, 1289, 3223, 1148, 1274, 3419, 1064, 3417,
	2363, 1264, 1613, 1058, 3408, 1516, 20346, 1191, 2356, 2137, 1614, 1292,
	1149, 2353, 3245, 1059, 1701, 1404, 1313, 2585, 2427, 1150, 3008, 2999,
	3000, 3003, 3001, 3006, 3002, 3005, 3004, 3400, 1055, 1041, 2354, 1026,
	1780, 3092, 2189, 20362, 1262, 20360, 20366, 20364, 1151, 1249, 1203, 1993,
	1956, 1870, 1988, 1255, 2022, 1061, 1379, 1180, 1715, 1718, 1620, 1044,
	1615, 2192, 2193, 1704, 2560, 1204, 1617, 3799, 3801, 3803, 3800, 3802,
	3804, 2083, 1189, 1686, 1087, 1273, 1190, 1152, 1023, 1153, 2555, 1038,
	1295, 1320, 2235, 1308, 1500, 2134, 1154, 3401, 1019, 1047, 1216, 1314,
	1256, 3621, 2364, 1155, 1156, 1157, 1158, 1202, 1159, 2021, 3387, 1049,
	1050, 3403, 1160, 1995, 2070, 1071, 1616, 20359, 1161, 1697, 1695, 1696,
	1694, 1693, 1077, 1402, 2132, 3391, 1031, 1619, 3384, 1002, 2203, 2420,
	20371, 2237, 1199, 1008, 1508, 20381, 1623, 1162, 2151, 1865, 3410, 1254,
	2086, 2091, 2221, 3226, 3222, 2017, 1163, 1276, 3029, 3154, 2197, 2532,
	1682, 3448, 3155, 3248, 1164, 3761, 3760, 3762, 3763, 2020, 1195, 20372,
	20375, 20376, 20377, 20378, 20419, 20373, 20374, 1052, 1012, 2422, 3175,
	1392, 1782, 3240, 2256, 3157, 3225, 1201, 2426, 1281, 2407, 1831, 2254,
	1492, 3409, 1165, 1062, 3190, 1243, 1916, 1166, 1167, 2087, 3406, 1001,
	3502, 3488, 3413, 1323, 1317, 3415, 3128, 2204, 1774, 1634, 3213, 3244,
	3211, 1074, 1401, 1037, 2199, 1776, 1754, 1755, 1076, 1290, 1196, 1169,
	1752, 3478, 1386, 3255, 3256, 3392, 1056, 1650, 1775, 1170, 1028, 1316,
	3242, 20353, 3622, 3741, 3390, 1014, 1322, 2201, 1174, 1278, 2239, 3752,
	1784, 1042, 3473, 1215, 3125, 1207, 1495, 1251, 1065, 1370, 2471, 3243,
	3787, 3754, 3499, 2956, 1829, 1069, 3254, 3443, 1584, 1583, 1986, 1175,
	1622, 3510, 3518, 1991, 1405, 1708, 1034, 1375, 1051, 1048, 1053, 1054,
	1960, 1961, 1959, 1958, 2313, 2314, 1089, 2959, 2073, 3501, 2227, 3232,
	3418, 1279, 1312, 20365, 2084, 1618, 1929, 3626, 1066, 1092, 1765, 1751,
	1771, 1676, 1677, 1678, 1679, 20363, 1621, 3633, 1032, 2355, 1685, 2989,
	2190, 1390, 3526, 1176, 1088, 2315, 1208, 3246, 2469, 3224, 2250, 3444,
	2188, 1179, 1630, 1648, 1653, 3498, 2208, 1261, 3389, 1010, 1263, 2419,
	3764, 3396, 1013, 1497, 1499, 1498, 3395, 1024, 1917, 1192, 1291, 3180,
	1512, 2535, 1057, 1979, 1200, 1177, 1178, 1514, 1417, 1015, 3452, 1298,
	1197, 1864, 1905,
]
